// src/auth/AdminAuthContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { type User } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

export type AdminRoles = "groupAdministrator" | "groupEditor";

function matchRoles(groupsList: string[]): string[] {
    const rolesList: string[] = [];
    const validRoles: Record<string, AdminRoles> = {
        "groupAdministrator": "groupAdministrator",
        "groupEditor": "groupEditor"
    };
    groupsList.forEach((role) => {
        if (validRoles[role]) {
            rolesList.push(validRoles[role]);
        }
    })
    return rolesList;
}

interface AdminAuthContextType {
  user: User | null;
  roles: string[] | null;
  loading: boolean;
}


const AdminAuthContext = createContext<AdminAuthContextType>({
  user: null,
  roles: null,
  loading: true
});

export function AdminAuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [roles, setRole] = useState<string[] | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const db = getFirestore();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setUser(user);
      if (user) {
        try {
          const userDocRef = doc(db, 'users', user.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            const userDocData = userDoc.data();
            if(userDocData.groups) {
                // setRole(matchRoles(userDocData.groups))
                let rolesList = matchRoles(userDocData.groups)
                setRole(rolesList)
            }
          } else {
            setRole(null);
          }
        } catch (e) {
          console.error('Error fetching user role:', e);
          setRole(null);
        }
      } else {
        setRole(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return (
    <AdminAuthContext.Provider value={{ user, roles, loading }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
